import React, { useState } from 'react';

const faqs = [
  {
    question: "EmlakVitrini TV nedir?",
    answer: "Kurumsal kullanıcıların ilanlarını Android TV cihazlarında vitrin olarak sergileyen bir uygulamadır."
  },
  {
    question: "Uygulamayı nasıl kullanırım?",
    answer: "Öncelikle emlakvitrini.net’ten kurumsal üyelik başlatın, ardından ilanlarınızı yükleyin ve TV uygulamasını cihazınıza kurarak görüntüleyin."
  },
  {
    question: "Hangi cihazlarda çalışır?",
    answer: "Android TV, Mi Box, Chromecast with Google TV gibi Android tabanlı cihazlarda çalışır."
  },
  {
    question: "İlanlarımı nasıl eklerim ?",
    answer: "Kurumsal üyeliğie geçişinizi yaptığınızda ilan ekle butonu aktif olur kolayca ilanlarınızı ekleyebilirsiniz."
  },
  {
    question: "ilanlarımı ekledim nasıl düzenleyebilirim ?",
    answer: "Aktif İlanlarım butonuna tıkladığınızda, ilanlarınızı görebilirsiniz. Düzenlemek istediğiniz ilanın üzerine tıklamanız yeterlidir. İlan başlığı, açıklaması, fiyatı gibi bilgileri düzenleyebilir; resim ekleyip çıkarabilir veya hangi resmin vitrin resmi olacağına karar verebilirsiniz."
  },
  {
    question: "Online mağazam ne ne zaman açılır ?",
    answer: "Kurumsal aboneliğe geçer geçmez online dükkanınızda açılır yaklaşık bir dakika sürüyor."
  },
  {
    question: "Online mağazam açıldı nasıl düzenlerim?",
    answer: "online mağazanız siz herhangi bir düzenleme yapana kadar standart şeklide kalır düzgün görünmesi için 1200px*300px bir banner kare bir logo yüklediğinizde sizin yükledikleriniz ile güncellenir ."
  },
  {
    question: "İlanların nerede görüneceğini nasıl ayarlarım?",
    answer: "Aktif ilanlarım penceresinde vitrin ve aktif seçenekleri ile bunu ayarlayabilirsiniz aktif internette yayınlandığını yada yayınlanmadığını vitrin kısmı ise Tv ekranında yayınlanıp yayınlanmadığını ayarlar.ilan ilk eklendiğinde ikiside aktiftir."
  },

  // İstediğin kadar ekleyebilirsin
];

const FaqAccordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div style={{ padding: '80px 20px', backgroundColor: '#ffffff' }}>
      <h2 style={{
        textAlign: 'center',
        fontSize: '36px',
        marginBottom: '40px',
        color: '#333',
        fontWeight: '700'
      }}>
        Sıkça Sorulan Sorular
      </h2>

      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        {faqs.map((faq, index) => (
          <div key={index} style={{
            marginBottom: '16px',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            overflow: 'hidden',
            backgroundColor: '#f8f8f8',
            transition: 'all 0.3s ease'
          }}>
            <div
              onClick={() => toggle(index)}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '20px 24px',
                cursor: 'pointer',
                fontSize: '18px',
                fontWeight: '600',
                color: '#444'
              }}
            >
              {faq.question}
              <span style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#4F75FF',
                transform: activeIndex === index ? 'rotate(45deg)' : 'rotate(0)',
                transition: 'transform 0.3s ease'
              }}>
                +
              </span>
            </div>
            <div
              style={{
                maxHeight: activeIndex === index ? '500px' : '0',
                overflow: 'hidden',
                transition: 'max-height 0.4s ease, padding 0.4s ease',
                padding: activeIndex === index ? '0 24px 20px 24px' : '0 24px'
              }}
            >
              <p style={{ color: '#555', fontSize: '16px', lineHeight: '1.6' }}>
                {faq.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqAccordion;
